module.exports = __webpack_public_path__ + "static/media/movieflix-mobile.38580bdd.svg";